module.exports = __webpack_public_path__ + "assets/img/ban7.8fd65116.png";